/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElAlert as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/alert/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import ultraUploadFile from '@ultra/share/utils/ultraUpload.js';
import UUpload from '@ultra/share/components/UUpload/index.vue';
import { apiUsdkBatchGetAgreementsV2, apiUsdkSaveThirdSdkPermission, apiUsdkThirdSdkPermissionList } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'baseRoot',
  props: {
    gid: {
      type: [String, Number],
      default: ''
    },
    sdkGameInfo: {
      type: Object,
      default: null
    }
  },
  emits: ['ok'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const root = {
      icon: '',
      name: '',
      des: ''
    };
    const dialogVisible = ref(false);
    const tableData = ref([]);
    const handleClick = (type, scope) => {
      console.log(scope);
      if (type === 'del') {
        tableData.value.splice(scope.$index, 1);
      } else {
        let last = tableData.value[tableData.value.length - 1];
        if (!last.icon[0].url) {
          ElMessage.warning('请上传icon！');
          return;
        } else if (!last.name) {
          ElMessage.warning('请填写权限名称！');
          return;
        } else if (!last.des) {
          ElMessage.warning('请填写权限用途！');
          return;
        }
        tableData.value.push({
          ...root
        });
      }
    };
    const tableLoading = ref(false);
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkThirdSdkPermissionList({
        gid: props.gid
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          tableData.value.push({
            ...root
          });
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const emits = __emit;
    const confirmLoading = ref(false);
    const handleSubmit = () => {
      confirmLoading.value = true;
      let data = tableData.value.filter(item => item.icon && item.name && item.des);
      data.forEach(item => {
        item.icon = Array.isArray(item.icon) ? item.icon[0].url : item.icon;
      });
      apiUsdkSaveThirdSdkPermission({
        gid: props.gid,
        data: JSON.stringify(data)
      }).then(res => {
        if (res.code === 0) {
          getTableData();
          handleClose();
          emits('ok');
          apiUsdkBatchGetAgreementsV2({
            gid: props.gid
          }).then(res => {
            if (res.code === 0) {
              res.data.forEach(item => {
                ultraUploadFile({
                  params: {
                    gid: props.sdkGameInfo.productID,
                    cid: item.cid,
                    text: JSON.stringify(item)
                  },
                  type: 3
                }).then(res => {
                  // console.log(res.url);
                });
              });
            }
          });
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    const show = () => {
      dialogVisible.value = true;
      getTableData();
    };
    __expose({
      show,
      handleClose
    });
    return (_ctx, _cache) => {
      const _component_el_alert = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_table = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "基础权限库",
        width: "900px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          title: "说明：基础权限库是作为数据保存的容器，其中数据不显示在渠道客户端。如需要在客户端对用户显示权限，还需要针对要显示权限的渠道勾选权限配置，配置时可单渠道也可批量渠道配置。",
          closable: false,
          type: "warning"
        }), _createVNode(_component_el_table, {
          loading: _unref(tableLoading),
          data: _unref(tableData),
          "max-height": "400",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "icon",
            label: "ICON",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(UUpload, {
              modelValue: scope.row.icon,
              "onUpdate:modelValue": $event => scope.row.icon = $event,
              limit: 1,
              "list-type": "picture-card"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "权限名称"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.name,
              "onUpdate:modelValue": $event => scope.row.name = $event,
              placeholder: "请输入权限名称"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "des",
            label: "权限用途"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.des,
              "onUpdate:modelValue": $event => scope.row.des = $event,
              placeholder: "请输入权限用途"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "60px"
          }, {
            default: _withCtx(scope => [!scope.row.id ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: $event => handleClick('del', scope),
              link: "",
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["loading", "data"]), _createVNode(_component_el_button, {
          class: "marginT10 width100",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("新增权限")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});